export default __webpack_public_path__ + "static/media/DSC_9136-thumb.5866e404.jpg";